export type DetailsOpenState = {
  summaryText: string;
  open: boolean;
};

function getSummaryText(details: HTMLDetailsElement): string {
  return details.querySelector('summary')?.textContent?.trim() ?? '';
}

export function captureDetailsOpenState(container: Element): DetailsOpenState[] {
  return Array.from(container.querySelectorAll('details')).map((details) => ({
    summaryText: getSummaryText(details),
    open: details.open,
  }));
}

export function applyDetailsOpenState(container: Element, states: DetailsOpenState[]): void {
  const detailsElements = container.querySelectorAll('details');

  states.forEach((state, index) => {
    const details = detailsElements[index];
    if (!details || getSummaryText(details) !== state.summaryText) {
      return;
    }

    details.open = state.open;
  });
}
